import i18n from 'i18n';
import { AxiosError } from 'axios'
import { ServerResponse } from 'data/types'
import { extractErrorMessage } from 'utils'
import { showSuccessMessage, showError } from 'shared/toaster';
import * as types from './fqdn.types'

const initalState: types.FqdnState = {
    items: [],
    isLoading: false,
    selectedItem: undefined,
    lastUpdatedAt: undefined,
}

const toastErrorMessage = (message: string) => showError(message, types.TOAST_MESSAGE_TIMEOUT);

const toastSuccessMessage = (message: string) => showSuccessMessage(message, types.TOAST_MESSAGE_TIMEOUT);

export default (state = initalState, { type, payload }: types.FqdnAction): types.FqdnState => {
    let items;
    switch (type) {
        case types.GET_FQDNS_PENDING:
        case types.CREATE_FQDN_PENDING:
        case types.UPDATE_FQDN_PENDING:
        case types.DELETE_FQDN_PENDING:
            return { ...state, isLoading: true }
        case types.GET_FQDNS_REJECTED:
        case types.CREATE_FQDN_REJECTED:
        case types.UPDATE_FQDN_REJECTED:
        case types.DELETE_FQDN_REJECTED:
            const errorMessage = extractErrorMessage(payload as unknown as AxiosError<ServerResponse<void>>)
            toastErrorMessage(errorMessage)
            return { ...state, isLoading: false }
        case types.CREATE_FQDN_FULFILLED:
            toastSuccessMessage(i18n.t('fqdn.create.success', { name: state.selectedItem?.fsId }));
            return {
                ...state, selectedItem: undefined, isLoading: false
            }
        case types.UPDATE_FQDN_FULFILLED:
            toastSuccessMessage(i18n.t('fqdn.update.success', { name: state.selectedItem?.fsId }));
            return { ...state, selectedItem: undefined, isLoading: false }
        case types.DELETE_FQDN_FULFILLED:
            toastSuccessMessage(i18n.t('fqdn.delete.success', { name: state.selectedItem?.fsId }));
            return {
                ...state, selectedItem: undefined, isLoading: false
            }
        case types.GET_FQDNS_FULFILLED:
            const lastUpdatedAt = new Date();
            items = Array.isArray(payload) ? payload : [];
            return {
                ...state, lastUpdatedAt, items, isLoading: false
            }
        case types.ON_SELECT_FQDN:
            const selectedItem = !Array.isArray(payload) ? payload : state.selectedItem;
            return { ...state, selectedItem }
        case types.ON_ENTER_FQDN_LIST_PAGE:
            return { ...state, selectedItem: undefined }
        default:
            return state;
    }

}
